

export const SEARCH_FETCH   = 'SEARCH_FETCH';    //full set
export const SEARCH_UPDATE  = 'SEARCH_UPDATE';   //change full set input
export const SEARCH_APPEND  = 'SEARCH_APPEND';   //add one line
export const SEARCH_CHANGE   = 'SEARCH_CHANGE';   // sync the input value to backend


